import { Record, Map, OrderedMap } from "immutable";

const CircuitsStateRecord = Record({
  circuitIdsByZoneId: Map(), // Map of Set
  circuits: Map(),
  circuitCategories: OrderedMap(),
  loading: false,
  error: null
});

export default CircuitsStateRecord;
